"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFUND_ERROR = exports.MONTHLY_DIRECT_DEBIT_ERROR = exports.CHANGE_DIRECT_DEBIT_AMOUNT_SUBMIT_ERROR = exports.CHANGE_DD_AMOUNT_SECTION_ID = exports.CHANGE_DD_AMOUNT_ERROR = exports.SETUP_DD_VIEW_ERROR_SECTION_ID = exports.SETUP_DD_SECTION_ID = exports.CHANGE_DD_DATE_SECTION_ID = exports.CHANGE_DIRECT_DEBIT_DATE_SUBMIT_ERROR = exports.CHANGE_DIRECT_DEBIT_DATE_ERROR = void 0;
exports.CHANGE_DIRECT_DEBIT_DATE_ERROR = 'change-direct-debit-date-error';
exports.CHANGE_DIRECT_DEBIT_DATE_SUBMIT_ERROR = 'change-direct-debit-date-submit-error';
exports.CHANGE_DD_DATE_SECTION_ID = 'change-dd-date';
exports.SETUP_DD_SECTION_ID = 'setup-dd';
exports.SETUP_DD_VIEW_ERROR_SECTION_ID = 'setup-dd-view-error';
exports.CHANGE_DD_AMOUNT_ERROR = 'change-dd-amount-error';
exports.CHANGE_DD_AMOUNT_SECTION_ID = 'change-dd-amount';
exports.CHANGE_DIRECT_DEBIT_AMOUNT_SUBMIT_ERROR = 'change-direct-debit-amount-submit-error';
exports.MONTHLY_DIRECT_DEBIT_ERROR = 'monthly-direct-debit-error';
exports.REFUND_ERROR = 'refund-error';
